import { render, staticRenderFns } from "./Pedido_Proveedor.vue?vue&type=template&id=395404f4&scoped=true"
import script from "./Pedido_Proveedor.vue?vue&type=script&lang=js"
export * from "./Pedido_Proveedor.vue?vue&type=script&lang=js"
import style0 from "./Pedido_Proveedor.vue?vue&type=style&index=0&id=395404f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395404f4",
  null
  
)

export default component.exports